import { call, put, takeEvery, select } from 'redux-saga/effects';
import { defineKqlQuery, searchSubmissions } from '@kineticdata/react';
import { C } from '@kineticdata/bundle-common';
import { actions, types } from '../modules/portfolio';
import { List } from 'immutable';

/**
 * Fetches the latest active record for the selected portfolio.
 */
export function* fetchPortfolioSaga({ payload }) {
  const authenticated = yield select(state => state.app.authenticated);
  const profile = yield select(state => state.app.profile);

  const query = defineKqlQuery()
    .equals(`values[${C.FIELD_STATUS}]`, 'status')
    .equals(`values[${C.FIELD_PORTFOLIO_ID}]`, 'id');
  if (!profile || !profile.hasInternalCatalogAccess) {
    query.equals(`values[Type]`, 'public');
  }

  const { submissions, error } = yield call(searchSubmissions, {
    kapp: C.KAPP_SLUG_DATASTORE,
    form: C.FORM_SLUG_PORTFOLIO,
    limit: 1000,
    search: {
      q: query.end()({
        status: 'Active',
        id: payload,
        public: 'Public',
      }),
      include: ['details', 'values', 'form'],
    },
    public: !authenticated,
  });

  if (error) {
    yield put(actions.fetchPortfolioFailure({ id: payload, error }));
  } else {
    // Sort returned portfolios by most recently updated and take the first one
    const currentPortfolio = List(submissions)
      .sortBy(p => p.updatedAt)
      .reverse()
      .first();

    if (!!currentPortfolio) {
      yield put(
        actions.fetchPortfolioSuccess({
          id: payload,
          data: currentPortfolio,
        }),
      );
    } else {
      yield put(
        actions.fetchPortfolioFailure({
          id: payload,
          error: {
            statusCode: 404,
            message: `Unable to locate the ${payload} portfolio`,
          },
        }),
      );
    }
  }
}

export function* watchPortfolio() {
  yield takeEvery(types.FETCH_PORTFOLIO_REQUEST, fetchPortfolioSaga);
}
